"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    optionGroupClassNames: function() {
        return optionGroupClassNames;
    },
    useOptionGroupStyles_unstable: function() {
        return useOptionGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const optionGroupClassNames = {
    root: 'fui-OptionGroup',
    label: 'fui-OptionGroup__label'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62",
        Belr9w4: "fiut8dr",
        B8lkq7l: "f1xxzjds",
        Gwp8xu: "fu19d3i",
        H93o2g: "flylvvz",
        eii1in: "f1ug5m11",
        om0q45: "f5642y",
        Hl9o3s: "ffdf81h",
        Bi9x0x4: "flgyru6",
        B0i58d9: [
            "f1fjgumo",
            "f1sgo0dv"
        ],
        sl1c2c: "fwsdxdw",
        z4hxbw: [
            "f1sgo0dv",
            "f1fjgumo"
        ]
    },
    label: {
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        sj55zd: "f11d4kpn",
        mc9l5x: "ftgm304",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fwrc4pm",
        z8tnut: "f17mpqex",
        z189sj: [
            "fdw0yi8",
            "fk8j09s"
        ],
        Byoj8tv: "fdvome7",
        uwmqm3: [
            "fk8j09s",
            "fdw0yi8"
        ]
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}",
        ".fiut8dr{row-gap:var(--spacingHorizontalXXS);}",
        ".f1xxzjds:not(:last-child)::after{content:\"\";}",
        ".fu19d3i:not(:last-child)::after{border-bottom-width:var(--strokeWidthThin);}",
        ".flylvvz:not(:last-child)::after{border-bottom-style:solid;}",
        ".f1ug5m11:not(:last-child)::after{border-bottom-color:var(--colorNeutralStroke2);}",
        ".f5642y:not(:last-child)::after{display:block;}",
        ".ffdf81h:not(:last-child)::after{padding-bottom:var(--spacingHorizontalXS);}",
        ".flgyru6:not(:last-child)::after{margin-top:0;}",
        ".f1fjgumo:not(:last-child)::after{margin-right:calc(var(--spacingHorizontalXS) * -1);}",
        ".f1sgo0dv:not(:last-child)::after{margin-left:calc(var(--spacingHorizontalXS) * -1);}",
        ".fwsdxdw:not(:last-child)::after{margin-bottom:var(--spacingVerticalXS);}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".ftgm304{display:block;}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f17mpqex{padding-top:var(--spacingHorizontalS);}",
        ".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",
        ".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",
        ".fdvome7{padding-bottom:var(--spacingHorizontalS);}"
    ]
});
const useOptionGroupStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(optionGroupClassNames.root, styles.root, state.root.className);
    if (state.label) {
        state.label.className = (0, _react.mergeClasses)(optionGroupClassNames.label, styles.label, state.label.className);
    }
    return state;
}; //# sourceMappingURL=useOptionGroupStyles.styles.js.map
